<!-- 验证完成组件 -->
<template id="finish">
  <section class="finish">
    <div class="s-form">
      <div class="s-form-row">
        <label class="s-form-label">
          <img src="../../images/personal_center/pops-ok.png" alt="完成" />
        </label>
        <div class="s-form-info">
          <h5>恭喜你，{{ finish_title }}！</h5>
          <p class="s-form-subtext">你的账户安全级别还能提升哦，快去完成其他的安全设置吧！</p>
        </div>
      </div>
      <div class="s-form-btnrow">
        <button type="button" class="s-button s-btn-success" @click="finish">我知道了</button>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: ['finish_title'],
    methods: {
      finish() {
        this.$emit('finish');
      }
    }
  }
</script>

<style media="screen" scoped lang="scss">
  .finish{
    width: 810px;
    padding-top: 100px;
    .s-form{
      &-label{
        width: 210px;
      }
      &-info{
        width: 580px;
        height: auto;
        line-height: initial;
      }
      &-subtext{
        margin-bottom: 30px;
      }
      h5{
        margin-bottom: 15px;
        color: #444444;
        font-size: 14px;
      }
    }
    .s-button{
      width: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// finish.vue?5e74cc06